import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';

interface TanstackQueryProviderProps {
  children: ReactNode,
}

export function TanstackQueryProvider(props: TanstackQueryProviderProps) {

  return (
    <QueryClientProvider client={ queryClient }>
      { props.children }
    </QueryClientProvider >
  );
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      gcTime: 0,
      refetchOnMount: true,
      retry: false,
      throwOnError: false,
      networkMode: 'always',
      refetchOnReconnect: false,
      placeholderData: (prev: any) => prev,
    },
    mutations: {
      throwOnError: false,
      networkMode: 'always',
    },
  },
});
